import React from 'react'
import store from '@/redux/store'
import ChangeTanModal from '@/modules/banking/components/change-tan-modal'
import { UNSAFE_renderElement as renderElement } from '@/hooks/useGlobalPortal'

export const openChangeTanModal = ({ transaction, processId, onSuccess, onError, onAbort = () => { } }) => {
  const { transactionId } = transaction

  return new Promise((resolve, reject) => {
    const getComponent = (close) => {
      return (
        <div data-transaction-id={transactionId}>
          <ChangeTanModal
            open={true}
            store={store}
            transaction={transaction}
            processId={processId}
            onSuccess={(data) => {
              close()
              onSuccess(data)
              resolve(data)
            }}
            onError={(error) => {
              close()
              onError(error)
              reject(error)
            }}
            onAbort={() => {
              close()
              onAbort()
              reject(transaction)
            }}
          />
        </div>
      )
    }

    renderElement(getComponent)
  })
}

export default openChangeTanModal
